import { Helmet } from "react-helmet-async";

const SITE_NAME = "OneBigBit Technologies Private Limited";
const SITE_URL = "https://onebigbit.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;
const DEFAULT_DESCRIPTION =
  "OneBigBit Technology Private Limited offers custom software development services tailored to your business needs. Contact us for top-notch IT solutions.";

/**
 * Per-page SEO meta tags for SPA routes.
 * @param {{ title?: string, description?: string, path?: string, image?: string, type?: string, noindex?: boolean, keywords?: string, jsonLd?: object|string|null }} props
 */
const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  keywords,
  jsonLd = null,
}) => {
  const pageTitle = title
    ? `${title} | ${SITE_NAME}`
    : SITE_NAME;
  const canonical = path.startsWith("http")
    ? path
    : `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
  const ogImage = image?.startsWith("http") ? image : `${SITE_URL}${image}`;

  let safeJsonLd = null;
  if (jsonLd) {
    try {
      const parsed = typeof jsonLd === "string" ? JSON.parse(jsonLd) : jsonLd;
      safeJsonLd = JSON.stringify(parsed);
    } catch {
      safeJsonLd = null;
    }
  }

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:secure_url" content={ogImage} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={pageTitle} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta itemprop="image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {safeJsonLd ? (
        <script type="application/ld+json">{safeJsonLd}</script>
      ) : null}
    </Helmet>
  );
};

export default Seo;
export { SITE_NAME, SITE_URL, DEFAULT_IMAGE, DEFAULT_DESCRIPTION };
